module.exports = "<uch></uch>\r\n<head-title params='title:\"操作日志\"'></head-title>\r\n<action-log></action-log>";


//////////////////
// WEBPACK FOOTER
// ./src/component/actionLog/actionLogIndex.html
// module id = 248
// module chunks = 0